import DeviceSubtypesTable from 'components/tables/data/device-subtypes/DeviceSubtypesTable';
import DashboardLayout from 'layouts/dashboard/DashboardLayout';
import { DEVICE_TYPES, getDeviceType } from 'model/DeviceType';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { DEVICE_TYPES_PAGE_PATH } from 'routes/paths';

/**
 * Page used to list device subtypes for a certain device type.
 *
 */
export default function DeviceSubtypesPage() {
  const { deviceTypeId: paramDeviceTypeId } = useParams();
  const deviceTypeId = useMemo(() => Number(paramDeviceTypeId ?? DEVICE_TYPES[0].id), [paramDeviceTypeId]);
  const deviceTypeName = useMemo(() => getDeviceType(deviceTypeId)?.name, [deviceTypeId]);

  return (
    <DashboardLayout
      height="screen"
      breadcrumbs={[
        { title: 'Nastavenia' },
        { title: 'Typy zariadení', link: DEVICE_TYPES_PAGE_PATH.original },
        { title: deviceTypeName },
      ]}
    >
      <DeviceSubtypesTable deviceTypeId={deviceTypeId} />
    </DashboardLayout>
  );
}
